import React from 'react'
import "./ChatNameListCard.css"
import MoreVertIcon from '@mui/icons-material/MoreVert';

function ChatNameListCard(props) {
    let { Name, userName, Profile } = props;
    return (
        <div className='CNLC-outerdiv container'>
            <div className="row">
            <img src={Profile} className='CNLC-profile_image g-col-6 h-75 mt-2' />
                <div className='CNLC-name1 g-col-4'>
                    <b>{Name}</b><br />
                    {userName}
                </div>
                <MoreVertIcon className="more_icon g-col-2 mt-4" />
            </div>


        </div>
    )
}

export default ChatNameListCard;